/**
 * @name        stripHtmlTagsFromString
 * @description Removes HTML tags from a given string.
 *              Example Input: "<p>This string has <strong>tags</strong>, some <i>even <u>nested</u></i>!</p>"
 *              Example Output: "This string has tags, some even nested!"
 * @param       {string} string the string to convert
 * @returns     {string} the string with the html tags removed
 */
function stripHtmlTagsFromString(string: string): string {
    return string.replace(/(<([^>]+)>)/ig, '');
}

export default stripHtmlTagsFromString;
